import { useMemo } from "react"
import { useQuery } from "urql"

import { type Query, UsersListDocument } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

const USERS_LIMIT = 200

interface UseGetInventoryAdjustmentHistoryUsersReturn {
  adjustedByOptions: Option<string>[]
  isFetching: boolean
}

export const useGetInventoryAdjustmentHistoryUsers = (): UseGetInventoryAdjustmentHistoryUsersReturn => {
  const [{ data, fetching: isFetching }] = useQuery<Pick<Query, "user">>({
    query: UsersListDocument,
    variables: { input: { filter: {}, limit: USERS_LIMIT, offset: 0 } },
  })

  const adjustedByOptions = useMemo<Option<string>[]>(() => {
    if (data?.user?.list?.__typename !== "UserListSuccess") return []
    return data.user.list.users
      .map((user) => ({ value: user.userId, label: user.name }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [data])

  return { adjustedByOptions, isFetching }
}
